import React, { useCallback, useRef, useState } from 'react';

import { DownOutlined } from '@ant-design/icons';

interface IProps {
  contentActive?: boolean;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  id?: string;
  arrow?: boolean;
  className?: string;
  onClick?: (expanded: boolean, element: HTMLDivElement | null) => void;
  noPadding?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

const MyCollapse: React.FC<IProps> = ({
  contentActive,
  icon,
  title,
  id,
  arrow,
  className,
  onClick,
  noPadding,
  disabled,
  children
}) => {
  const [expanded, setExpanded] = useState(contentActive);
  const divRef = useRef<HTMLDivElement>(null);

  const handleExpandClick = useCallback(() => {
    if (disabled) return;

    setExpanded(prev => {
      const next = !prev;

      if (onClick) {
        onClick(next, divRef.current);
      }

      return next;
    });
  }, [onClick, disabled]);

  return (
    <div
      id={id || (typeof title === 'string' ? title : undefined)}
      ref={divRef}
      className={`rounded-sm border border-solid border-[#eee] bg-white ${disabled ? 'pointer-events-none opacity-50' : ''} ${className || ''}`}
    >
      <div
        className='flex cursor-pointer items-center justify-between gap-2 px-4 py-3 text-sm font-semibold text-[#596375] select-none'
        onClick={handleExpandClick}
      >
        <div className='flex items-center gap-2'>
          {icon && <span className='flex items-center text-base'>{icon}</span>}
          <span>{title}</span>
        </div>

        {arrow && (
          <DownOutlined
            className={`text-xs text-[#999] transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`}
          />
        )}
      </div>

      <div className={noPadding ? '' : 'px-4'}>
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${expanded ? 'max-h-[2000px] pb-3 opacity-100' : 'max-h-0 opacity-0'}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MyCollapse;
